import { lazy, Suspense, useEffect } from "react";
import { trackPageView } from "@/lib/pixel";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SocialProofBar from "@/components/SocialProofBar";
import PhotoBreak from "@/components/PhotoBreak";
import HeroFoldBreak from "@/components/HeroFoldBreak";

import photoBreak1 from "@/assets/photo-break-1.jpg";
import photoBreak2 from "@/assets/photo-break-2.jpg";
import photoBreak3 from "@/assets/photo-break-3-new.jpg";
import photoBreak4 from "@/assets/photo-break-4-new.jpg";

const About = lazy(() => import("@/components/About"));
const Problems = lazy(() => import("@/components/Problems"));
const Benefits = lazy(() => import("@/components/Benefits"));
const TransformationGallery = lazy(() => import("@/components/TransformationGallery"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const ModuleCovers = lazy(() => import("@/components/ModuleCovers"));
const Bonuses = lazy(() => import("@/components/Bonuses"));
const ForWhom = lazy(() => import("@/components/ForWhom"));
const Pricing = lazy(() => import("@/components/Pricing"));
const GuaranteeSection = lazy(() => import("@/components/GuaranteeSection"));
const FAQ = lazy(() => import("@/components/FAQ"));
const Footer = lazy(() => import("@/components/Footer"));
const FloatingCTA = lazy(() => import("@/components/FloatingCTA"));
const ExitIntentPopup = lazy(() => import("@/components/ExitIntentPopup"));

const Index = () => {
  useEffect(() => {
    trackPageView();
  }, []);

  return (
    <div className="min-h-screen bg-background pb-20 md:pb-0">
      <Header />
      <main>
        <Hero />
        <SocialProofBar />
        
        <Suspense fallback={<div className="min-h-[50vh]" />}>
          <About />
          <HeroFoldBreak />
          <Problems />
          <PhotoBreak src={photoBreak1} alt="Maquiagem artística - transição para benefícios" />
          <Benefits />
          <PhotoBreak src={photoBreak2} alt="Pincéis e ferramentas de maquiagem" />
          <TransformationGallery />
          <Testimonials />
          <HowItWorks />
          <ModuleCovers />
          <Bonuses />
          <PhotoBreak src={photoBreak3} alt="Camilla sorrindo com produto de beleza" />
          <ForWhom />
          <PhotoBreak src={photoBreak4} alt="Camilla com look premium" />
          <Pricing />
          <GuaranteeSection />
          <FAQ />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <FloatingCTA />
        <ExitIntentPopup />
      </Suspense>
    </div>
  );
};

export default Index;
